module.exports = __webpack_public_path__ + "static/media/Gellert Grindelwald 1.fa90d789.jpg";